import { useState } from 'react'

const useAttributeSelectorDrawer = (attributesSelectorItems = []) => {
  const [showDrawer, toggleDrawer] = useState(false)
  const [selectedAttributeSelectorData, setAttributeSelectorData] = useState(null)

  const onDrawerOpen = index => {
    toggleDrawer(true)
    setAttributeSelectorData(attributesSelectorItems[index])
  }

  const onDrawerClose = (selectedProduct = {}, currentVariant = {}, callbackFn = () => {}) => {
    toggleDrawer(false)
    setAttributeSelectorData(null)
    callbackFn(selectedProduct, currentVariant)
  }

  return {
    showDrawer,
    selectedAttributeSelectorData,
    onDrawerOpen,
    onDrawerClose
  }
}

export default useAttributeSelectorDrawer
